import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=6a12bf88&scoped=true"
import script from "./newsItem.vue?vue&type=script&lang=js"
export * from "./newsItem.vue?vue&type=script&lang=js"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=6a12bf88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12bf88",
  null
  
)

export default component.exports